export default __webpack_public_path__ + "static/media/info.2fc0cbf2.svg";